import React from 'react';
import PropTypes from 'prop-types';
import StyledTitle from '../../hoc/StyledTitle';
import ToolTip from '../AssetPropertyView';

@StyledTitle
class A extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    title: PropTypes.string
  };

  render() {
    const { children, title, ...props } = this.props;
    return (
      <a name="A" {...props}>
        <ToolTip text={title ? title : null}> {children}</ToolTip>
      </a>
    );
  }
}

export default A;
